import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo, useState } from "react";
import { useTranslate } from "../../../context/TranslationContext";
import Button from "../../button";
import YoutubeVideoModel from "../../modal/YoutubeVideoModel";
import "./style.css";

const CalculatorCard = (props) => {
  const { data, content } = props;
  const { t } = useTranslate("staticData");

  const [showYoutubeModal, setShowYoutubeModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const handleWatchVideo = (e) => {
    e.stopPropagation();
    const matchedSection = content?.data?.sections?.find(
      (section) => section.title.toLowerCase() === data.link.toLowerCase(),
    );
    if (matchedSection) {
      setVideoUrl(matchedSection.content);
      setShowYoutubeModal(true);
    }
  };

  return (
    <div className="calculator-card">
      {/* Thumbnail */}
      <div className="calculator-card-thumbnail" onClick={handleWatchVideo}>
        <img
          src={data?.image}
          alt={data?.title}
          className="calculator-card-image"
        />

        <div className="play-overlay">
          <div className="play-button">
            <i className="fa-solid fa-play"></i>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="calculator-card-content">
        <div className="calculator-card-text px-3">
          <h5 className="calculator-title">
            <span className="calculator-icon">
              <FontAwesomeIcon icon={data?.icon} />
            </span>

            {data?.title}
          </h5>

          <p>{data?.description}</p>
        </div>

        {/* Actions */}
        <div className="calculator-card-actions">
          <button className="site-btn border-btn" onClick={handleWatchVideo}>
            <FontAwesomeIcon icon={faPlay} /> Watch Demo
          </button>

          <Button
            text={t("calcNow")}
            className="site-btn text-center"
            to={data?.route}
          />
        </div>
      </div>

      <YoutubeVideoModel
        show={showYoutubeModal}
        close={() => setShowYoutubeModal(false)}
        videoUrl={videoUrl}
        title={data?.title}
      />
    </div>
  );
};

export default memo(CalculatorCard);
